import type { RouteRecordRaw } from 'vue-router';

export const tradeSubscriberRoutes: Array<RouteRecordRaw> = [
  {
    path: '/trade/subscriber',
    name: 'tradeSubscriber',
    redirect: '/trade/subscriber/list',
    component: () => import('pages/trade/admin/subscriber/McSubscriber.vue'),
    meta: {
      title: 'Subscribers',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSubscriberList',
        component: () => import('pages/trade/admin/subscriber/SubscriberList.vue'),
        meta: {
          title: 'Subscribers List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSubscriberDetail',
        component: () => import('pages/trade/admin/subscriber/SubscriberDetail.vue'),
        meta: {
          title: 'Subscriber Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSubscriberNew',
        component: () => import('pages/trade/admin/subscriber/SubscriberNew.vue'),
        meta: {
          title: 'New Subscriber',
          requiresAuth: true,
        },
      },
    ],
  },
];
